// hooks
import useAuth from '../hooks/useAuth';
// utils
import createAvatar from '../utils/createAvatar';
//
import Avatar from './Avatar';

// ----------------------------------------------------------------------

export default function MyAvatar({ ...other }) {
  const { user } = useAuth();

  return (
    <Avatar
      src={user?.crew?.randomhash ? `https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/crewji/crewji_${user?.crew?.randomhash}.png` : null}
      alt={user?.username}
      color={user?.crew?.randomhash ? 'default' : createAvatar(user?.username).color}
      {...other}
    >
      {createAvatar(user?.username).name}
    </Avatar>
  );
}
